module.exports = __webpack_public_path__ + "img/resume.5b9c4e04.jpg";